import React, { FC } from "react";
import { Login } from "./Login";
import { LoginAction } from "./LoginAction";

export const LoginFailedPage: FC = () => {
  return (
    <Login action={LoginAction.LoginFailed} returnUrl={window.location.href} />
  );
};
